export default __webpack_public_path__ + "static/074-f3f9e578478f4c0656684fd21658900b.jpg";